export const GET_EVENTS_CALENDAR = "GET_EVENTS_CALENDAR"
export const GET_EVENTS_CALENDAR_SUCCESS = "GET_EVENTS_CALENDAR_SUCCESS"
export const GET_EVENTS_CALENDAR_FAILED = "GET_EVENTS_CALENDAR_FAILED"

export const GET_CALENDAR_EVENT = "GET_CALENDAR_EVENT"
export const GET_CALENDAR_EVENT_SUCCESS = "GET_CALENDAR_EVENT_SUCCESS"
export const GET_CALENDAR_EVENT_FAILED = "GET_CALENDAR_EVENT_FAILED"

export const GET_ALL_EVENTS_CALENDAR = "GET_ALL_EVENTS_CALENDAR"
export const GET_ALL_EVENTS_CALENDAR_SUCCESS = "GET_ALL_EVENTS_CALENDAR_SUCCESS"
export const GET_ALL_EVENTS_CALENDAR_FAILED = "GET_ALL_EVENTS_CALENDAR_FAILED"

export const GET_ALL_CALENDAR_EVENTS = "GET_ALL_CALENDAR_EVENTS"
export const GET_ALL_CALENDAR_EVENTS_SUCCESS = "GET_ALL_CALENDAR_EVENTS_SUCCESS"
export const GET_ALL_CALENDAR_EVENTS_FAILED = "GET_ALL_CALENDAR_EVENTS_FAILED"

export const GET_EVENT_CALENDAR_GROUP = "GET_EVENT_CALENDAR_GROUP"
export const GET_EVENT_CALENDAR_GROUP_SUCCESS =
  "GET_EVENT_CALENDAR_GROUP_SUCCESS"
export const GET_EVENT_CALENDAR_GROUP_FAILED = "GET_EVENT_CALENDAR_GROUP_FAILED"
export const RESET_EVENT_CALENDAR_GROUP = "RESET_EVENT_CALENDAR_GROUP"

export const CREATE_EVENT_CALENDAR = "CREATE_EVENT_CALENDAR"
export const CREATE_EVENT_CALENDAR_SUCCESS = "CREATE_EVENT_CALENDAR_SUCCESS"
export const CREATE_EVENT_CALENDAR_FAILED = "CREATE_EVENT_CALENDAR_FAILED"

export const UPDATE_EVENT_CALENDAR = "UPDATE_EVENT_CALENDAR"
export const UPDATE_EVENT_CALENDAR_SUCCESS = "UPDATE_EVENT_CALENDAR_SUCCESS"
export const UPDATE_EVENT_CALENDAR_FAILED = "UPDATE_EVENT_CALENDAR_FAILED"

export const DELETE_EVENT_CALENDAR = "DELETE_EVENT_CALENDAR"
export const DELETE_EVENT_CALENDAR_SUCCESS = "DELETE_EVENT_CALENDAR_SUCCESS"
export const DELETE_EVENT_CALENDAR_FAILED = "DELETE_EVENT_CALENDAR_FAILED"
export const OPEN_DELETE_EVENT_CALENDAR_MODAL =
  "OPEN_DELETE_EVENT_CALENDAR_MODAL"
export const HIDE_DELETE_EVENT_CALENDAR_MODAL =
  "HIDE_DELETE_EVENT_CALENDAR_MODAL"
export const CHECK_EVENT_CALENDAR_CAN_BE_DELETED =
  "CHECK_EVENT_CALENDAR_CAN_BE_DELETED"
export const CHECK_EVENT_CALENDAR_CAN_BE_DELETED_SUCCESS =
  "CHECK_EVENT_CALENDAR_CAN_BE_DELETED_SUCCESS"
export const CHECK_EVENT_CALENDAR_CAN_BE_DELETED_FAILED =
  "CHECK_EVENT_CALENDAR_CAN_BE_DELETED_FAILED"

export const OPEN_CLONE_EVENT_CALENDAR_MODAL = "OPEN_CLONE_EVENT_CALENDAR_MODAL"
export const HIDE_CLONE_EVENT_CALENDAR_MODAL = "HIDE_CLONE_EVENT_CALENDAR_MODAL"
export const CLONE_EVENT_CALENDAR = "CLONE_EVENT_CALENDAR"
export const CLONE_EVENT_CALENDAR_SUCCESS = "CLONE_EVENT_CALENDAR_SUCCESS"
export const CLONE_EVENT_CALENDAR_FAILED = "CLONE_EVENT_CALENDAR_FAILED"

export const DELETE_CALENDAR_EVENT = "DELETE_CALENDAR_EVENT"
export const DELETE_CALENDAR_EVENT_SUCCESS = "DELETE_CALENDAR_EVENT_SUCCESS"
export const DELETE_CALENDAR_EVENT_FAILED = "DELETE_CALENDAR_EVENT_FAILED"
export const OPEN_DELETE_CALENDAR_EVENT_MODAL =
  "OPEN_DELETE_CALENDAR_EVENT_MODAL"
export const HIDE_DELETE_CALENDAR_EVENT_MODAL =
  "HIDE_DELETE_CALENDAR_EVENT_MODAL"
